import { formatDate } from '../../../../utilities';

export const formatMetadataValue = (value: string): string => {
  if (value === null || value === undefined) {
    return '';
  }

  if (Array.isArray(value)) {
    return value.join(', ');
  }

  if (typeof value === 'string') {
    const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
    if (dateRegex.test(value)) {
      try {
        const date = new Date(value);
        return formatDate(date.toISOString());
      } catch {
        return value;
      }
    }
    return value;
  }

  return String(value);
};
